export const ParamTypes = {
  NUMBER: 'number',
  STRING: 'string',
  ARRAY: 'array',
  BOOLEAN: 'boolean'
};